import React from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { HiPhone, HiEnvelope } from 'react-icons/hi2';
import { FaWhatsapp } from 'react-icons/fa';

const QuickContactBar = () => {
  const { t } = useTranslation();

  const handleCall = (e) => {
    e.preventDefault();
    window.location.href = 'tel:+213560667120';
  };

  const handleWhatsApp = (e) => {
    e.preventDefault();
    window.open('https://wa.me/213560667120', '_blank');
  };

  const handleEmail = (e) => {
    e.preventDefault();
    window.location.href = 'mailto:fpra2024@gmail.com';
  };

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white dark:bg-gray-900 border-t border-gray-200 dark:border-gray-700 shadow-lg z-30 md:hidden">
      <div className="grid grid-cols-4 gap-0.5 p-1">
        {/* Call */}
        <button
          onClick={handleCall}
          className="flex flex-col items-center justify-center py-1.5 px-0.5 text-orange hover:bg-orange-50 dark:hover:bg-orange-900/30 rounded-lg transition-colors"
        >
          <HiPhone className="h-5 w-5 mb-0.5" />
          <span className="text-[10px] font-medium leading-tight">{t('quickContact.call')}</span>
        </button>

        {/* WhatsApp */}
        <button
          onClick={handleWhatsApp}
          className="flex flex-col items-center justify-center py-1.5 px-0.5 text-green-500 hover:bg-green-50 dark:hover:bg-green-900/30 rounded-lg transition-colors"
        >
          <FaWhatsapp className="h-5 w-5 mb-0.5" />
          <span className="text-[10px] font-medium leading-tight">{t('quickContact.whatsapp')}</span>
        </button>

        {/* Email */}
        <button
          onClick={handleEmail}
          className="flex flex-col items-center justify-center py-1.5 px-0.5 text-teal hover:bg-teal-50 dark:hover:bg-teal-900/30 rounded-lg transition-colors"
        >
          <HiEnvelope className="h-5 w-5 mb-0.5" />
          <span className="text-[10px] font-medium leading-tight">{t('quickContact.email')}</span>
        </button>

        {/* Contact Page */}
        <Link
          to="/contact"
          className="flex flex-col items-center justify-center py-1.5 px-0.5 text-gray-700 dark:text-gray-300 dark:text-gray-300 hover:bg-gray-100 dark:hover:bg-gray-800 rounded-lg transition-colors"
        >
          <svg className="h-5 w-5 mb-0.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
          </svg>
          <span className="text-[10px] font-medium leading-tight">{t('quickContact.viewContact')}</span>
        </Link>
      </div>
    </div>
  );
};

export default QuickContactBar;
